import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { CommuneRequestBody, CommuneResponse } from "./types";

export class CommuneAPI extends BaseAPI<
    CommuneRequestBody,
    CommuneResponse
> {
    protected route = ApiRoutes.search.commune;
    protected method = RequestMethod.GET;
    protected params = ["district_id"];
} 